import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { ICardTagsPanelButton } from './types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { CARD_SECTION_TAGS } from '../../constants';
import { CLASS_CARD_DETAILS_SECTION, SECTION_CREATION_WAITING_TIME } from '../../../constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { getAsidePanelActionsButtonTooltip } from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';

export function CardTagsPanelButton({
    isShow,
    tagsCount,
    tooltip,
    onClick
}: ICardTagsPanelButton) {
    if (!isShow) return null;

    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--tags';

    const { isCommentsColumn, cardId, showedProperties, openedProperty, addShowedProperty } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_TAGS) && openedProperty !== EAsidePanelProperty.CARD_TAGS;
    const [isOpened, setIsOpened] = React.useState(null);
    const onOpened = () => setIsOpened(true);
    const onClosed = () => setIsOpened(false);

    return (
        <AsidePanelActionsButton
            indicatorNumber={tagsCount}
            icon={'tag'}
            isOpened={isOpened}
            openedProperty={EAsidePanelProperty.CARD_TAGS}
            sectionSelector={`.${classNameSection}`}
            title={CARD_SECTION_TAGS}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_TAGS, isCommentsColumn);
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, SECTION_CREATION_WAITING_TIME);
                }
            }}
            onOpen={onOpened}
        >
        </AsidePanelActionsButton>
    );
}
